import * as Filter from '../components/filterGroup';

export function OnActiveTabChanged(s, e) {
    const $sharedWithMeSearchBox: JQuery<HTMLElement> = $('#ProcessListSharedWithMe_SearchPanel_CustomEditorName');
    const $sharedWithBySearchBox: JQuery<HTMLElement> = $('#ProcessListSharedByMe_SearchPanel_CustomEditorName');

    if (e.tab.index === 0) {
        $sharedWithMeSearchBox.parent().show();
        $sharedWithBySearchBox.parent().hide();
    } else {
        $sharedWithMeSearchBox.parent().hide();
        $sharedWithBySearchBox.parent().show();
    }
}

export function OnRDSharedInit() {
    if (document.getElementById('shared-processes-search-panels')) {
        Filter.Init();
    }

    const $sharedWithBySearchBox: JQuery<HTMLElement> = $('#ProcessListSharedByMe_SearchPanel_CustomEditorName');
    $sharedWithBySearchBox.parent().hide();
}
